export enum SpecialWagerTypesNamesEnum {
  ADVANCE = "ADVANCE",
  FUTURE = "FUTURE",
  NON_CONSECUTIVE_PICK = "NONCONSECUTIVEPICK"
}

export enum SpecialWagerTypesAbbreviationEnum {
  ADVANCE = "ADV",
  FUTURE = "FUT",
  NON_CONSECUTIVE_PICK = "NCP"
}

export interface SpecialWagerType {
  specialCardTypeName: SpecialWagerTypesNamesEnum;
  specialCardTypeAbbreviation: SpecialWagerTypesAbbreviationEnum;
}

export interface SpecialCardSourceRace {
  cardDate: string;
  trackCode: string;
  trackName: string;
  trackShortname: string;
  raceNumber?: string;
}
